export const STATEMENT_ID = 'settlement_statement_id';
